import axios from "../utils/axios";

// ==========================================
// Admin Webhooks (Backend Sprint 15)
// ==========================================

export const getWebhooks = async (params) => {
    const response = await axios.get("/admin/webhooks", { params });
    return response.data;
};

export const getWebhookById = async (id) => {
    const response = await axios.get(`/admin/webhooks/${id}`);
    return response.data;
};

export const createWebhook = async (data) => {
    const response = await axios.post("/admin/webhooks", data);
    return response.data;
};

export const updateWebhook = async (id, data) => {
    const response = await axios.put(`/admin/webhooks/${id}`, data);
    return response.data;
};

export const deleteWebhook = async (id) => {
    const response = await axios.delete(`/admin/webhooks/${id}`);
    return response.data;
};

export const rotateWebhookSecret = async (id) => {
    const response = await axios.post(`/admin/webhooks/${id}/rotate-secret`);
    return response.data;
};

// ==========================================
// Webhook deliveries
// ==========================================

export const getWebhookDeliveries = async (webhookId, params) => {
    const response = await axios.get(`/admin/webhooks/${webhookId}/deliveries`, { params });
    return response.data;
};

export const replayWebhookDelivery = async (deliveryId) => {
    const response = await axios.post(`/admin/webhooks/deliveries/${deliveryId}/replay`);
    return response.data;
};
